module.exports = __webpack_public_path__ + "static/img/expert-login-bg.9c4bea8b.png";